import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCreateAccount } from '../../../hooks/useAccount';
import { validateEmail, toTitleCase } from '../../../constants/helpers';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
  
const cancelIcon = <FontAwesomeIcon icon={faXmark} />
const checkIcon = <FontAwesomeIcon icon={faCheck} />

export default function NewVendor() {
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [vendorName, setVendorName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('VT');
  const [zip, setZip] = useState('');
  const [errors, setErrors] = useState([]);

  const create = useCreateAccount();

  const validate = () => {
    const e = [];

    if (!vendorName) e['vendorName'] = 'required';
    if (!email) e['email'] = 'required';
    if (!validateEmail(email)) e['email'] = 'invalid email';

    setErrors(e);
    return Object.keys(e).length === 0;
  }

  const onChange = (e, setter) => {
    e.preventDefault();

    setter(e.target.value);
  }

  const save = () => {
    if (!validate()) return false;

    create.mutate({
      first_name: toTitleCase(firstName),
      last_name: toTitleCase(lastName),
      vendor_name: toTitleCase(vendorName),
      email: email.toLowerCase().trim(),
      phone: phone.trim(),
      address1: toTitleCase(address1),
      address2: toTitleCase(address2),
      city: toTitleCase(city),
      state: state.toUpperCase().trim(),
      zip: zip.trim(),
      role: 'vendor'
    });

    navigate('/admin/vendors');
  }

  return (
    <div className="container has-text-left">
      <div className="title">Add Vendor</div>
      <div className="field">
        <label className="label">Vendor Name <span style={{ color: 'red' }}>*</span></label>
        <div className="control">
          <input className="input" type="text" name="vendorName" onChange={e => onChange(e, setVendorName)} value={vendorName} />
          {errors.vendorName && <div className="has-text-danger has-text-weight-semibold">{errors.vendorName}</div>}
        </div>
      </div>

      <div className="columns is-mobile">
        <div className="column">
          <div className="field">
            <label className="label">First Name</label>
            <div className="control">
              <input className="input" type="text" name="firstName" onChange={e => onChange(e, setFirstName)} value={firstName} />
              {errors.firstName && <div className="has-text-danger has-text-weight-semibold">{errors.firstName}</div>}
            </div>
          </div>
        </div>

        <div className="column">
          <div className="field">
            <label className="label">Last Name</label>
            <div className="control">
              <input className="input" type="text" name="lastName" onChange={e => onChange(e, setLastName)} value={lastName} />
              {errors.lastName && <div className="has-text-danger has-text-weight-semibold">{errors.lastName}</div>}
            </div>
          </div>
        </div>
      </div>

      <div className="field">
        <label className="label">Email <span style={{ color: 'red' }}>*</span></label>
        <div className="control">
          <input className="input" type="text" name="email" onChange={e => onChange(e, setEmail)} value={email} />
          {errors.email && <div className="has-text-danger has-text-weight-semibold">{errors.email}</div>}
        </div>
      </div>

      <div className="field">
        <label className="label">Phone</label>
        <div className="control">
          <input
            className="input"
            type="text"
            name="phone"
            mask="(999) 999-9999"
            onChange={e => onChange(e, setPhone)}
            value={phone}
          />
          {errors.phone && <div className="has-text-danger has-text-weight-semibold">{errors.phone}</div>}
        </div>
      </div>

      <div className="field">
        <label className="label">Mailing Address Line 1</label>
        <div className="control">
          <input className="input" type="text" name="address1" onChange={e => onChange(e, setAddress1)} value={address1} />
          {errors.address1 && <div className="has-text-danger has-text-weight-semibold">{errors.address1}</div>}
        </div>
      </div>

      <div className="field">
        <label className="label">Address Line 2</label>
        <div className="control">
          <input className="input" type="text" name="address2" onChange={e => onChange(e, setAddress2)} value={address2} />
        </div>
      </div>

      <div className="field">
        <label className="label">City</label>
        <div className="control">
          <input className="input" type="text" name="city" onChange={e => onChange(e, setCity)} value={city} />
          {errors.city && <div className="has-text-danger has-text-weight-semibold">{errors.city}</div>}
        </div>
      </div>

      <div className="columns is-mobile">
        <div className="column">
          <div className="field">
            <label className="label">State</label>
            <div className="control">
              <input className="input" type="text" name="state" onChange={e => onChange(e, setState)} value={state} />
              {errors.state && <div className="has-text-danger has-text-weight-semibold">{errors.state}</div>}
            </div>
          </div>
        </div>

        <div className="column is-two-thirds">
          <div className="field">
            <label className="label">Zip</label>
            <div className="control">
              <input className="input" type="text" name="zip" onChange={e => onChange(e, setZip)} value={zip} />
              {errors.zip && <div className="has-text-danger has-text-weight-semibold">{errors.zip}</div>}
            </div>
          </div>
        </div>
      </div>

      <div className="mb-6">
        <div className="buttons is-grouped">
          <button className="button is-link" onClick={save} disabled={create.isLoading}>
            <span className="icon">
              <i>{checkIcon}</i>
            </span>
            <span>Save</span>
          </button>
          <button className="button is-info" onClick={() => navigate('/admin/vendors')}>
            <span className="icon">
              <i>{cancelIcon}</i>
            </span>
            <span>Cancel</span>
          </button>
        </div>
      </div>
    </div>
  )
}
